<div class="show-by-modal">
  <app-finance-modal-header title="Show by" (closed)="cancel()"></app-finance-modal-header>

  <div class="modal-body">
    <div class="column-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
      <div *ngFor="let id of order" class="column-row" cdkDrag>
        <span class="drag-handle" cdkDragHandle aria-label="Drag to reorder">
          <mat-icon>open_with</mat-icon>
        </span>
        <mat-checkbox
          color="primary"
          [checked]="visibleMap[id]"
          (change)="toggleVisible(id)"
          (click)="$event.stopPropagation()"
        >
          <span class="column-label">{{ labelFor(id) }}</span>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button class="reset-btn" type="button" (click)="reset()">Reset</button>
    <div class="footer-right">
      <button mat-stroked-button class="cancel-btn" type="button" (click)="cancel()">Cancel</button>
      <button mat-flat-button class="apply-btn" type="button" (click)="apply()">Apply</button>
    </div>
  </div>
</div>
